import { Text, colors } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'

interface InsightsPortalTitleProps {
  'data-testid'?: string
}

export const InsightsPortalTitle: FunctionComponent<InsightsPortalTitleProps> = ({
  'data-testid': testId,
  children,
}) => (
  <Text
    size="large"
    weight="bold"
    data-testid={testId}
    css={{ marginBottom: 15, color: colors.GRAYSCALE.X70 }}
  >
    {children}
  </Text>
)
